import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserLogged } from '@models';
import { AuthService } from '@services';
import { interval, Subscription } from 'rxjs';
import { timeInterval } from 'rxjs/operators';

@Component({
  selector: 'ggi-journey-end-of-visit-video',
  templateUrl: './end-of-visit-video.component.html',
  styleUrls: ['./end-of-visit-video.component.scss'],
})
export class EndOfVisitVideoComponent implements OnInit {
  public statusCopy: boolean;

  private counter: Subscription;

  public user: UserLogged;

  public projectLink: string;
  public videoLink: string;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    public readonly auth: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.projectLink = params.projectLink;
      this.videoLink = params.videoLink;
    });
    this.getClientFromStorage();
  }

  public getClientFromStorage(): void {
    const user = this.auth.getUser();
    if (user) {
      this.user = user;
    }
  }

  /**
   * Copy the text from the link input
   */
  public copyText(val: string): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.statusCopy = true;

    const counter = interval(1000);
    this.counter = counter.pipe(timeInterval()).subscribe((res) => {
      if (res.value === 1) {
        this.counter.unsubscribe();
        this.statusCopy = false;
      }
    });
  }

  public goToLogin(): void {
    let url: string;
    switch (this.user.application) {
      case 'CLIENT':
        url = 'cliente/dashboard';
        break;
      case 'BROKER':
      case 'BROKERLEADER':
        url = 'broker/agenda-de-visitas';
        break;
      case 'ADMIN':
      case 'SUPERADMIN':
        url = 'admin/proyectos';
        break;

      default:
        url = '/iniciar-sesion';

        break;
    }

    this.router.navigateByUrl(url);
  }

  public goToProject(): void {
    const routeLink =
      this.projectLink.includes('http') || this.projectLink.includes('https')
        ? this.projectLink
        : `https://${this.projectLink}`;

    window.location.href = routeLink;
  }
}
